import { render, staticRenderFns } from "./FamilyRewardsCard.vue?vue&type=template&id=228dc3bb"
import script from "./FamilyRewardsCard.vue?vue&type=script&lang=js"
export * from "./FamilyRewardsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports